import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const images = [
  'https://images.unsplash.com/photo-1511192336575-5a79af67a629?w=500&q=80',
  'https://images.unsplash.com/photo-1464375117522-1311d6a5b81f?w=400&q=80',
  'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&q=80',
  'https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f?w=400&q=80',
  'https://images.unsplash.com/photo-1487180144351-b8472da7d491?w=400&q=80',
  'https://images.unsplash.com/photo-1524650359799-842906ca1c06?w=400&q=80',
  'https://images.unsplash.com/photo-1501612780327-45045538702b?w=500&q=80',
  'https://images.unsplash.com/photo-1519892300165-cb5542fb47c7?w=400&q=80',
  'https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=400&q=80',
  'https://images.unsplash.com/photo-1598387993441-a364f854b4b4?w=400&q=80',
  'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=400&q=80',
  'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=400&q=80',
];

const features = [
  {
    title: 'Find Band Members',
    desc: 'Post a free ad or browse profiles to find the perfect drummer, vocalist, guitarist or any other musician for your project.',
  },
  {
    title: 'Book Rehearsal Spaces',
    desc: 'Discover and book fully-equipped, local rehearsal studios by the hour or day.',
  },
  {
    title: 'Join Local Projects',
    desc: 'Connect with bands looking for members for gigs, recordings, or new collaborations.',
  },
];

const BandPromoSection = () => {
  const navigate = useNavigate();

  return (
    <section style={{ background: '#0f172a', padding: '20px 20px', overflow: 'hidden' }}>
      <style>{`
        @media (max-width: 768px) {
          .band-promo-flex { gap: 32px !important; }
          .band-promo-text { order: -1; }
          .band-promo-grid { grid-template-rows: repeat(4, 100px) !important; }
        }
      `}</style>
      <div className="band-promo-flex" style={{
        maxWidth: '1200px', margin: '0 auto', padding: '0 24px',
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '60px',
      }}>

        {/* ── Left: mosaic grid ── */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="band-promo-mosaic"
          style={{ flex: '1 1 420px' }}
        >
          <div className="band-promo-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridTemplateRows: 'repeat(4, 130px)',
            gap: '6px',
            borderRadius: '16px',
            overflow: 'hidden',
          }}>
            {/* Row 1 */}
            <div style={{ gridColumn: '1/2', gridRow: '1/3', overflow: 'hidden' }}>
              <img src={images[0]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
            <div style={{ overflow: 'hidden' }}>
              <img src={images[1]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
            <div style={{ gridColumn: '3/4', gridRow: '1/3', overflow: 'hidden' }}>
              <img src={images[2]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
            <div style={{ overflow: 'hidden' }}>
              <img src={images[3]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>

            {/* Row 3 */}
            <div style={{ overflow: 'hidden' }}>
              <img src={images[4]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
            <div style={{ overflow: 'hidden' }}>
              <img src={images[5]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
            <div style={{ gridColumn: '1/2', gridRow: '3/5', overflow: 'hidden' }}>
              <img src={images[6]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>

            {/* Row 4 */}
            <div style={{ overflow: 'hidden' }}>
              <img src={images[7]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
            <div style={{ overflow: 'hidden' }}>
              <img src={images[8]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
            <div style={{ overflow: 'hidden' }}>
              <img src={images[9]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
            <div style={{ overflow: 'hidden' }}>
              <img src={images[10]} alt="musician" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
            </div>
          </div>
        </motion.div>

        {/* ── Right: text ── */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="band-promo-text"
          style={{ flex: '1 1 320px' }}
        >
          <h2 style={{
            fontFamily: 'Gilroy-semiBold, sans-serif',
            fontWeight: 700,
            fontSize: 'clamp(1.8rem, 3.5vw, 2.6rem)',
            color: '#fff',
            lineHeight: 1.2,
            marginBottom: '16px',
            letterSpacing: '-0.02em',
          }}>
            For Musicians &amp; Bands<br />Who Want to Play More
          </h2>

          <p style={{
            color: '#94a3b8',
            fontSize: '1rem',
            lineHeight: 1.75,
            fontFamily: 'Poppins, sans-serif',
            marginBottom: '32px',
          }}>
            MusicalMeet streamlines your musical journey. We connect you directly with the local musicians, bands, and rehearsal spaces you need to make playing more a reality — not just a goal.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', marginBottom: '36px' }}>
            {features.map((f, i) => (
              <div key={i} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <div style={{
                  minWidth: 36, height: 36, borderRadius: '50%',
                  background: 'rgba(55,78,169,0.25)',
                  border: '2px solid rgba(55,78,169,0.5)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  marginTop: '2px',
                }}>
                  <svg width="14" height="11" viewBox="0 0 14 11" fill="none">
                    <path d="M1 5.5L5 9.5L13 1.5" stroke="#818cf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div>
                  <p style={{ color: '#fff', fontFamily: 'Gilroy-semiBold, sans-serif', fontWeight: 700, fontSize: '1rem', marginBottom: '4px' }}>
                    {f.title}
                  </p>
                  <p style={{ color: '#94a3b8', fontFamily: 'Poppins, sans-serif', fontSize: '0.9rem', lineHeight: 1.6 }}>
                    {f.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => navigate('/login?signup=1&artist=1')}
            style={{
              width: '100%', maxWidth: '320px',
              background: '#374EA9', color: '#fff',
              border: 'none', borderRadius: '10px',
              padding: '15px 32px', fontSize: '1rem',
              fontFamily: 'Gilroy-semiBold, sans-serif',
              fontWeight: 600, cursor: 'pointer',
              boxShadow: '0 4px 16px rgba(55,78,169,0.4)',
              transition: 'background 0.2s, transform 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#4a62d6'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#374EA9'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            Get Started
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default BandPromoSection;
